export function FolderSoft({ ...props }) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M18.3333 9.16666V14.1667C18.3333 17.5 17.5 18.3333 14.1667 18.3333H5.83332C2.49999 18.3333 1.66666 17.5 1.66666 14.1667V5.83333C1.66666 2.5 2.49999 1.66666 5.83332 1.66666H7.08332C8.33332 1.66666 8.60832 2.03333 9.08332 2.66666L10.3333 4.33333C10.65 4.75 10.8333 5 11.6667 5H14.1667C17.5 5 18.3333 5.83333 18.3333 9.16666Z"
        stroke="black"
        strokeOpacity="0.54"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
    </svg>
  );
}
